import { useContext } from 'react'
import { AppMainContext } from '../context/AppMainContext';
import { useNavigate } from 'react-router-dom';

export default function AddTask() {
  const { taskFlag, setTaskConstancy, setTaskContent, handleAddTask, taskConstancy, taskContent } = useContext(AppMainContext);

  const nav = useNavigate();
  return (
    <div className='addTask_div'>
      <div className='addTask_inputs'>
        <input className='addTask_content' type="text" placeholder='תוכן המשימה' onChange={(e)=>{setTaskContent(e.target.value)}} value={taskContent} maxLength={40}/>
        <label htmlFor="addTask_constancy">משימה קבועה</label>
        <input id='addTask_constancy' className='addTask_constancy' type="checkbox" onChange={(e)=>{setTaskConstancy(e.target.checked)}}  checked={taskConstancy}/>
      </div>
      <button className='addTask_saveBtn' disabled={taskFlag} onClick={()=>{handleAddTask(nav)}}>{taskFlag ? "טוען..." : "הוסף"}</button>
    </div>
  )
}
